import React from "react";
import { cn } from "@/utils/cn";

export type FeatureCardProps = {
  icon: React.ReactNode;
  title: string;
  description: string;
  className?: string;
};

export const FeatureCard: React.FC<FeatureCardProps> = ({
  icon,
  title,
  description,
  className,
}) => (
  <div
    className={cn("platform-card flex items-center gap-4 rounded-2xl bg-white p-6", className)}
  >
    <div className="h-20 w-20 shrink-0">{icon}</div>
    <div className="flex flex-col gap-2">
      <h4 className="body-a-bold md:subtitle-b-bold text-black">
        {title}
      </h4>
      <p className="caption-regular text-black md:body-b-regular">
        {description}
      </p>
    </div>
  </div>
);
